import moment from 'moment';
import React, {useMemo, useState } from 'react';
import ColorDots from '../../components/colorDot';
import ImgHolder from '../../components/imgHolder';
import { useGroupChatContext } from '../../context/groupchatContext';
import { isPatientChatMessage, TimeAgo } from '../../helpers/utility';

const RecentChat = ({chat, onClickChatThread}) => {

    const groupChatContext = useGroupChatContext();
    const [patientGroupColors, setPatientGroupColors] = useState([]);

    const {selectedChat} = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
    }));

    const PatientTagInfo = () => {
        return (
            <>
                <div className="h-[42px] w-[42px] shrink-0 rounded-full">
                    <ImgHolder uuid={chat.patient?.file ? chat.patient?.file : chat.patient?.sex} />
                </div>
                <div>
                    <ColorDots dots={chat.patient?.patient_group_color} />
                </div>
                <div className="overflow-hidden text-left w-40">
                    <p className="text-md text-start font-medium text-gray-900 custom-text-ellipsis" title={chat.patient?.fname+' '+chat.patient?.lname}>{chat.patient?.fname+' '+chat.patient?.lname}</p>
                    <p className="text-xs text-start font-medium text-gray-500" >MRN: {chat.patient?.mrn}</p>
                    <p className="text-xs text-start font-medium text-gray-500"><span className='capitalize'>{chat.patient?.sex}</span>, {`${moment(chat.patient?.DOB).format("MM/DD/YYYY")} (${chat.patient?.age} Y)`}</p>
                    <p className="truncate text-sm font-normal text-slate-400" title={chat.location?.name}>{chat.location?.name}</p>
                    {/* <p className="truncate text-sm font-normal text-slate-400">{chat.message?.text}</p> */}
                </div>
            </>
        )
    }

    const LocationTagInfo = () => {
        return (
            <div className="overflow-hidden text-left w-48">
                <p className="text-md text-start font-medium text-gray-900 custom-text-ellipsis" title={chat.location?.name}>{chat.location?.name}</p>
                <p className="truncate text-sm font-normal text-slate-400" title={chat.location?.address1}>{chat.location?.address1}</p>
            </div>
        )
    }

    const isChatThreadSelected = () => {
        if(isPatientChatMessage(chat)){
            return chat.pid == selectedChat.pid;
        } else {
            return chat.location_id == selectedChat.location_id;
        }
    }

    if(!chat){
        return null;
    }


    return (
        <button className={`flex items-center gap-2 w-full px-2 py-2 transition-colors duration-300 hover:bg-light-gray-f1 border-b-[1px] ${isChatThreadSelected() ? 'bg-light-gray-f1' : ''}`}  onClick={()=>onClickChatThread(chat)}>
            {isPatientChatMessage(chat) ? <PatientTagInfo /> : <LocationTagInfo /> }
            <div className="ml-auto flex flex-col items-end gap-1 text-right">
                {/* <ReactTimeAgo timeStyle="round-minute" date={new Date(chat.created)} /> */}
                {chat.created ? <p className="text-xs text-slate-400 mb-3 min-w-[5rem]"> <TimeAgo date={new Date(chat.created)} flow='recent_chat' /></p> : null}
                {chat.unread_message_count ? <p title="Unread Messages" className={`h-4 px-1.5 place-content-center rounded-full bg-green-500 text-xs text-slate-200 ${chat.unread_message_count > 99 ? 'min-w-[2rem]' : ''}`}>{chat.unread_message_count}</p> : null}
                {chat.unread_urgent_count ? <p title="Urgent Messages" className={`h-4 px-1.5 place-content-center rounded-full bg-red-500 text-xs text-slate-200 ${chat.unread_urgent_count > 99 ? 'min-w-[2rem]' : ''}`}>{chat.unread_urgent_count}</p> : null}
                {chat.unread_mention_count ? <p title="Mentions" className={`h-4 px-1.5 place-content-center rounded-full bg-[#93c5fd] text-xs text-slate-200 ${chat.unread_mention_count > 99 ? 'min-w-[2rem]' : ''}`}>{chat.unread_mention_count}</p> : null}
            </div>
        </button>
    );
};

export default RecentChat;
